import { render, staticRenderFns } from "./EventBagPopup.vue?vue&type=template&id=68697a0c&scoped=true&"
import script from "./EventBagPopup.vue?vue&type=script&lang=js&"
export * from "./EventBagPopup.vue?vue&type=script&lang=js&"
import style0 from "./EventBagPopup.vue?vue&type=style&index=0&id=68697a0c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68697a0c",
  null
  
)

export default component.exports